var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { MyRemaxModes, LoginSource } from '../../classes/enums';
import { CommunicationService } from './../../services/communication.service';
import { Router } from '@angular/router';
import { HasSubscriptions } from './../has-subscriptions';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PreferencesService } from '../../services/preferences.service';
import { PreRenderService } from '../../services/pre-render.service';
import { ConfirmationService } from '../../services/confirmation/confirmation.service';
import { CredentialsService } from '../../services/credentials.service';
import { MANAGE_NOTIFICATION_PATH } from '../../app-config.constants';
import { takeWhile } from 'rxjs/operators';
var MyRemaxComponent = /** @class */ (function (_super) {
    __extends(MyRemaxComponent, _super);
    function MyRemaxComponent(router, communicationService, _preferencesService, activatedRoute, credentialsService, prerenderService, translationService, confirmationService) {
        var _this = _super.call(this) || this;
        _this.router = router;
        _this.communicationService = communicationService;
        _this._preferencesService = _preferencesService;
        _this.activatedRoute = activatedRoute;
        _this.credentialsService = credentialsService;
        _this.prerenderService = prerenderService;
        _this.translationService = translationService;
        _this.confirmationService = confirmationService;
        _this.savedSearches = [];
        _this.showShare = false;
        _this.isAuthenticated = false;
        _this.breadcrumbs = [];
        _this.showChangesSaved = false;
        // enums:
        _this.MyRemaxModes = MyRemaxModes;
        return _this;
    }
    MyRemaxComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.prerenderService.setPreRenderFlag(200);
        if (this.router.url === MANAGE_NOTIFICATION_PATH) {
            this.myRemaxMode = MyRemaxModes.MANAGE_NOTIFICATIONS;
            this.checkLogin();
        }
        this.addSub(this.activatedRoute.queryParamMap.subscribe(function (paramsMap) {
            switch (paramsMap.get('mode')) {
                case MyRemaxModes.SAVED_SEARCHES: {
                    _this.myRemaxMode = MyRemaxModes.SAVED_SEARCHES;
                    break;
                }
                default: {
                    _this.myRemaxMode = MyRemaxModes.FAVOURITES;
                }
            }
            _this._updateBreadcrumbs();
        }));
        this.addSub(this._preferencesService.savedSearchesChanged.subscribe(function (savedSearches) {
            _this.savedSearches = savedSearches;
        }));
    };
    MyRemaxComponent.prototype.checkLogin = function () {
        var _this = this;
        this.addSub(this.credentialsService.isLoggedIn.subscribe(function (isAuthenticated) {
            var popup = !isAuthenticated && _this.myRemaxMode === MyRemaxModes.MANAGE_NOTIFICATIONS ? { popup: ['register-login', LoginSource.Generic] } : {};
            _this.openRegisterLogin(popup);
        }));
    };
    MyRemaxComponent.prototype.openRegisterLogin = function (popup) {
        var _this = this;
        this.router.navigate(['/', { outlets: popup }])
            .then(function () {
            _this.showSavedSearches();
        });
    };
    MyRemaxComponent.prototype.showFavourites = function () {
        this.myRemaxMode = MyRemaxModes.FAVOURITES;
        this.communicationService.activeMyRemaxMode.next(this.myRemaxMode);
        this._updateBreadcrumbs();
    };
    MyRemaxComponent.prototype.showSavedSearches = function () {
        this.myRemaxMode = MyRemaxModes.SAVED_SEARCHES;
        this._updateBreadcrumbs();
    };
    MyRemaxComponent.prototype.startSavedSearch = function () {
        this.router.navigate(['/find-real-estate']);
    };
    MyRemaxComponent.prototype.deleteAllSavedSearches = function () {
        if (this.confirmationService.showConfirmation(this.translationService.instant('my-remax.saved-searches.confirm-all-delete')))
            this._preferencesService.deleteAllSavedSearches();
    };
    MyRemaxComponent.prototype.deleteSavedSearch = function (s) {
        if (this.confirmationService.showConfirmation(this.translationService.instant('my-remax.saved-searches.confirm-single-delete')))
            this._preferencesService.deleteSavedSearch(s);
    };
    MyRemaxComponent.prototype.updateNotificationEnabledOnSavedSearches = function (savedSearches) {
        var _this = this;
        var saveSearchUpdated = false;
        this.addSub(this.credentialsService.isLoggedIn
            .pipe(takeWhile(function () { return saveSearchUpdated === false; }))
            .subscribe(function (isAuthenticated) {
            if (isAuthenticated) {
                _this.updateSavedSearches(savedSearches);
                _this.showChangesSaved = true;
                saveSearchUpdated = true;
            }
            else if (!isAuthenticated) {
                _this.updateSavedSearches(savedSearches);
                saveSearchUpdated = true;
                _this.router.navigate(['/', { outlets: { popup: ['register-login', LoginSource.Radar] } }]);
            }
        }));
    };
    MyRemaxComponent.prototype.updateSavedSearches = function (savedSearches) {
        var _this = this;
        savedSearches.forEach(function (ss) {
            _this._preferencesService.updateNotificationOnSavedSearch(ss);
        });
    };
    MyRemaxComponent.prototype.restoreSavedSearch = function (s) {
        var _this = this;
        // TODO: works for some reason with the timeout, find out why
        setTimeout(function () {
            _this.communicationService.notifications.bottomNotification.next(_this.translationService.instant('actions.restore-saved-search', { x: s.name }));
        }, 0);
        this._preferencesService.restoreSavedSearch(s);
        this.communicationService.selectedSaveSearch.next(s);
        this.router.navigate(['/find-real-estate']);
    };
    MyRemaxComponent.prototype.home = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.router.navigate(['/find-real-estate'])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MyRemaxComponent.prototype._updateBreadcrumbs = function () {
        this.communicationService.activeMyRemaxMode.next(this.myRemaxMode);
        this.breadcrumbs = [
            {
                key: 'breadcrumbs.listing',
                url: '/find-real-estate',
                queryParams: null,
                isActive: true
            },
        ];
        if (this.myRemaxMode === MyRemaxModes.SAVED_SEARCHES) {
            this.breadcrumbs.push({
                key: 'breadcrumbs.saved-search',
                url: '/my-remax',
                queryParams: {
                    mode: 'saved-searches'
                },
                isActive: true
            });
        }
        else if (this.myRemaxMode === MyRemaxModes.FAVOURITES) {
            this.breadcrumbs.push({
                key: 'breadcrumbs.saved-listings',
                url: '/my-remax',
                queryParams: {
                    mode: 'favourites'
                },
                isActive: true
            });
        }
    };
    return MyRemaxComponent;
}(HasSubscriptions));
export { MyRemaxComponent };
